import clsx from 'clsx';
import React, { ComponentPropsWithoutRef, forwardRef } from 'react';

import styles from './styles.scss';
import { ButtonProps } from './Button';

type LinkButtonProps = ButtonProps & ComponentPropsWithoutRef<'a'>;

const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(
  ({ href, children, className, variant = 'default', ...otherProps }, ref) => {
    return (
      <a
        ref={ref}
        href={href}
        className={clsx(styles.btn, styles[variant], className)}
        {...otherProps}
      >
        {children}
      </a>
    );
  }
);

export default LinkButton;
